














































import { Component, Prop } from 'vue-property-decorator'

import { ButtonView, SocketNames } from '../../../../../../components'
import { SampleNodeMixin } from '../../../../index'
import { CheckLimitedSubscriptionNode } from '../../logic/CheckLimitedSubscriptionNode'

@Component({
  components: {
    ButtonView,
  },
  data() {
    return {
      SocketNames,
    }
  }
})
export default class CheckLimitedSubscriptionsSampleNode extends SampleNodeMixin {
  @Prop() node!: CheckLimitedSubscriptionNode

  get channelTitle(): string {
    const channel = this.node.nodeProps.targets().find((t) => t.id === this.node.data.target)

    if (channel) {
      return channel.title
    }

    return this.i18n.t('channel_not_found').toString()
  }
}
